import { Col, Pagination, Row, Table } from "antd";
import Modal from "antd/lib/modal/Modal";
import HorizontalBarChart from "components/charts/HorizontalBarChart";
import PieChartWrap from "components/charts/PieChartWrap";
import { StackedBarChart } from "components/charts/StackedBarChart";
import FilterSelect from "components/FilterSelect";
import LoadingSpinner from "components/LoadingSpinner";
import RangeDateFilter from "components/RangeDateFilter";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  getAuthorStats,
  getLanguage,
  getPublications,
  getResource,
  getSentiment,
  getSentimentData,
  getSentimentResourceStats,
  getTopics,
} from "./api";
import { COLORS, SENTIMENT_TYPES } from "./constants";
import { LineChart } from "./LineChart";
import Publication from "./Publication";
import WorldNews from "./WorldNews";

const currentD = moment(); //.format().valueOf();
const FORMAT = "YYYY-MM-DDTHH:mm:ss",
  FORMAT_NULL = "YYYY-MM-DDT00:00:00";
const TEMPLATE = [
    {
      label: "Сегодня",
      value: "day",
    },
    {
      label: "Неделя",
      value: "week",
    },
    {
      label: "Текущий месяц",
      value: "month",
    },
    {
      label: "Год",
      value: "year",
    },
  ],
  CHOOSE_TEMP = {
    day: {
      from: currentD.format(FORMAT_NULL),
      to: currentD.format(FORMAT),
    },
    week: {
      from: moment().clone().startOf("week").format(FORMAT_NULL),
      to: currentD.format(FORMAT),
    },
    month: {
      from: moment().clone().startOf("month").format(FORMAT_NULL),
      to: currentD.format(FORMAT),
    },
    year: {
      from: moment().clone().startOf("year").format(FORMAT_NULL),
      to: currentD.format(FORMAT),
    },
  },
  SENTIMENT_SMI = {
    social: "Социальные сети",
    mass: "Новостные каналы",
  };

export default function MonitoringSmi() {
  const [filter, setFilter] = useState({
    from: moment().subtract(1, "d").format(FORMAT),
    to: moment().format(FORMAT),
    sentimentId: null,
    topicId: null,
    page: 0,
    size: 10,
  });
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({});
  const [modal, setModal] = useState({ visible: false, type: "", data: [] });

  console.log("publications", stats, filter, modal);

  const TONALITY = Object.keys(SENTIMENT_TYPES).map((k) => ({
    label: SENTIMENT_TYPES[k],
    value: k,
  }));

  useEffect(() => {
    setLoading(true);
    let filterUrl = "";
    Object.keys(filter).forEach((k) => {
      if (filter[k] !== null) filterUrl = filterUrl + `${k}=${filter[k]}&`;
    });

    Promise.all([
      getPublications(filterUrl),
      getSentimentData(filterUrl),
      getSentimentResourceStats(filterUrl),
      getResource(filterUrl),
      getLanguage(filterUrl),
      getAuthorStats(filterUrl),
      getSentiment(),
      getTopics(),
    ]).then(
      ([
        publications,
        sentimentData,
        sentimentResourceStats,
        resource,
        language,
        authors,
        sentiment,
        topics,
      ]) => {
        setStats({
          publications,
          sentimentData: sentimentData?.map((i) => ({
            category: i.date,
            ...i,
          })),
          sentimentResourceStats: sentimentResourceStats?.map((i) => ({
            category: SENTIMENT_TYPES[i.sentimentId],
            [SENTIMENT_SMI.social]: i.social,
            [SENTIMENT_SMI.mass]: i.mass,
          })),
          resource: resource?.map((i) => ({
            category: i.name,
            value: i.total,
          })),
          language: language?.map((i) => ({
            category: i.name,
            value: i.total,
          })),
          authors: authors?.map((i) => ({
            category: i.authorName,
            [SENTIMENT_TYPES[1]]: i.sentiment1,
            [SENTIMENT_TYPES[2]]: i.sentiment2,
            [SENTIMENT_TYPES[3]]: i.sentiment3,
            [SENTIMENT_TYPES[16]]: i.sentiment16,
          })),
          sentiment,
          topics: topics?.map((i) => ({
            label: i.name,
            value: i.id,
          })),
        });
        setLoading(false);
      }
    );
  }, [filter]);

  const handleChangeFilter = (filterData) => {
    setFilter({ ...filter, ...filterData });
  };

  const handleChangeDate = ([from, to]) => {
    setFilter({
      ...filter,
      from: from.format(FORMAT_NULL),
      to: to.format(FORMAT_NULL),
    });
  };

  const handleChangeTemp = ({ temp }) => {
    setFilter({ ...filter, ...CHOOSE_TEMP[temp] });
  };

  const handleClick = (filter) => {
    console.log("setDateCrime", filter);
  };

  const handleClear = (type) => {
    setFilter({
      from: moment().subtract(1, "d").format(FORMAT),
      to: moment().format(FORMAT),
      sentimentId: null,
      topicId: null,
      page: 0,
      size: 10,
    });
  };

  const onChangePagination = (p) => {
    setFilter({ ...filter, page: p });
  };

  const ModalTableHeaders = {
    publications: [
      {
        title: "Дата публикации",
        dataIndex: "createdDate",
        key: "createdDate",
      },
      {
        title: "Заголовок",
        dataIndex: "title",
        key: "title",
      },
      {
        title: "Текст",
        dataIndex: "text",
        key: "text",
      },
      {
        title: "Источник",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "Тональность",
        dataIndex: "sentimentId",
        key: "id",
        render: (id) => <>{SENTIMENT_TYPES[id]}</>,
      },
      {
        title: "Автор",
        dataIndex: "authorName",
        key: "authorName",
      },
    ],
  };

  return (
    <>
      <Row className="mb20" gutter={16}>
        <Col span={6}>
          <RangeDateFilter
            startDate={filter.from}
            endDate={filter.to}
            value={[
              moment(filter.from, "YYYY-MM-DD"),
              moment(filter.to, "YYYY-MM-DD"),
            ]}
            setRange={handleChangeDate}
            width={"100"}
          />
        </Col>
        <Col span={6}>
          <FilterSelect
            options={TEMPLATE}
            filterField="temp"
            handleChange={handleChangeTemp}
            handleClear={handleClear}
            placeholder={"Шаблон"}
            allowClear
            maxWidth="100%"
          />
        </Col>
        <Col span={6}>
          <FilterSelect
            options={TONALITY}
            filterField="sentimentId"
            handleChange={handleChangeFilter}
            handleClear={handleClear}
            placeholder={"Тональность"}
            allowClear
            maxWidth="100%"
          />
        </Col>
        <Col>
          <FilterSelect
            options={stats.topics || []}
            filterField="topicId"
            handleChange={handleChangeFilter}
            handleClear={handleClear}
            placeholder={"Smart Aqmola"}
            allowClear
            maxWidth="100%"
          />
        </Col>
      </Row>
      <Row className="mb20" gutter={16}>
        {/* <Col span={6}>
          {stats.publications?.content?.map((p, index) => (
            <Publication
              key={index}
              {...p}
              onClick={(d) =>
                setModal({ visible: true, type: "publications", data: d })
              }
            />
          ))}

          <Pagination
            pageSize={filter.size}
            size="small"
            current={filter.page}
            onChange={onChangePagination}
            total={stats?.publications?.totalPages}
            style={{ color: "#fff" }}
          />
        </Col> */}
        <Col span={24}>
          <h3 style={{ textAlign: "center" }}>Тональность по дате</h3>
          <LoadingSpinner loading={loading}>
            <LineChart tension data={stats.sentimentData} id="sentimentid" />
          </LoadingSpinner>
          <Row className="mb20">
            <Col span={12}>
              <h3 style={{ textAlign: "center" }}>Язык публикации</h3>
              <LoadingSpinner loading={loading}>
                <HorizontalBarChart
                  data={stats.language}
                  noCellSize
                  id="categoryChart"
                  color="#F2C80F"
                  height="40vh"
                  //height={chartHeight}
                  // handleClick={(category) => {
                  //   this.showModal("category", category);
                  // }}
                  advancedScroll
                  advancedScrollStart={0.5}
                  advancedScrollEnd={1}
                  key={stats.language?.length}
                />
              </LoadingSpinner>
            </Col>
            <Col span={12}>
              <h3 style={{ textAlign: "center" }}>Топ авторов публикации</h3>
              <LoadingSpinner loading={loading}>
                <StackedBarChart
                  id="authorsStackedBarId"
                  sort
                  data={stats.authors}
                  height="44vh"
                  stack={Object.keys(SENTIMENT_TYPES).map((k, index) => ({
                    field: SENTIMENT_TYPES[k],
                    name: SENTIMENT_TYPES[k],
                  }))}
                  handleClick={() => console.log("CLick")}
                  colorsArr={COLORS}
                />
              </LoadingSpinner>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="mb20" gutter={16}>
        <Col span={12}>
          <h3 style={{ textAlign: "center" }}>Медиа</h3>
          <LoadingSpinner loading={loading}>
            <PieChartWrap
              id="levels"
              data={stats.resource}
              height="43vh"
              hideLabels
              handleClick={(category) => console.log("category", category)}
              colorsArr={COLORS}
              showLegend={true}
            />
          </LoadingSpinner>
        </Col>
        <Col span={12}>
          <h3 style={{ textAlign: "center" }}>Тональность в разрезе СМИ</h3>
          <LoadingSpinner loading={loading}>
            <StackedBarChart
              id="sentimentStackedBarId"
              sort
              data={stats.sentimentResourceStats}
              height="44vh"
              stack={Object.keys(SENTIMENT_SMI).map((k) => ({
                field: SENTIMENT_SMI[k],
                name: SENTIMENT_SMI[k],
              }))}
              handleClick={() => console.log("CLick")}
              colorsArr={COLORS}
            />
          </LoadingSpinner>
        </Col>
      </Row>

      <WorldNews />

      <Modal
        title="Обращения"
        className="appeals_modal"
        visible={modal.visible}
        onOk={() => setModal({ visible: false, data: [] })}
        onCancel={() => setModal({ visible: false, data: [] })}
        footer={null}
        width={1200}
        bodyStyle={{
          height: "60vh",
        }}
      >
        <div className="table_height">
          {modal.data.length > 0 && (
            <Table
              columns={ModalTableHeaders[modal.type]}
              dataSource={modal.data}
              height="75vh"
            />
          )}
        </div>
      </Modal>
    </>
  );
}
